import React from 'react';
import './EventPreview.css';
import { format, parseISO, getYear, addDays } from 'date-fns';

const EventPreview = ({ event, onClose }) => {
  if (!event) {
    return <div className="event-preview-pane"></div>;
  }

  // --- Date and Link Generation ---
  let formattedDate = 'Date not available';
  let eventDate;
  if (event.event_date) {
    const parsedDate = parseISO(event.event_date);
    if (!isNaN(parsedDate)) {
      eventDate = parsedDate;
      formattedDate = format(eventDate, 'PPPP');
    }
  }

  const dateQuery = eventDate ? format(eventDate, 'yyyy-MM-dd') : '';
  const checkoutDateQuery = eventDate ? format(addDays(eventDate, 2), 'yyyy-MM-dd') : '';
  const locationQuery = encodeURIComponent(`${event.city}, ${event.country}`);
  
  // --- THIS IS THE FIX ---
  // The search query now only includes the event title and city.
  const genericSearchQuery = encodeURIComponent(`${event.title} ${event.city || ''}`);
  // --- END FIX ---
  
  const learnMoreLink = `https://www.google.com/search?q=${genericSearchQuery}`;
  const bookingLink = `https://www.booking.com/searchresults.html?ss=${locationQuery}&checkin=${dateQuery}&checkout=${checkoutDateQuery}&group_adults=2&aid=YOUR_BOOKING_ID_HERE`;
  const kayakLink = `https://www.kayak.com/hotels/${locationQuery}/${dateQuery}/${checkoutDateQuery}/2adults?a=YOUR_KAYAK_ID_HERE`;
  const expediaLink = `https://expedia.com/affiliates/expedia-home.6M3BeY3`;
  const tripadvisorLink = `https://www.tripadvisor.com/Search?q=${genericSearchQuery}`;

  return (
    <div className={`event-preview-pane ${event ? 'open' : ''}`}>
      <button onClick={onClose} className="close-button">&times;</button>
      <h2>{event.title}</h2>
      <p><strong>Date:</strong> {formattedDate}</p>
      <p><strong>Location:</strong> {event.city}, {event.country}</p>
      <p><strong>Category:</strong> {event.category}</p>
      <p><strong>Continent:</strong> {event.continent}</p>
      
      <div className="description-section">
        <h3>Description</h3>
        <p>{event.description || 'No description available for this event.'}</p>
        <a href={learnMoreLink} target="_blank" rel="noopener noreferrer" className="platform-button learn-more">
          Learn more about this event
        </a>
      </div>

      <div className="travel-needs-section">
        <h3>Plan Your Trip</h3>
        <div className="platform-links-container">
          <a href={bookingLink} target="_blank" rel="noopener noreferrer" className="platform-button booking-com">
            Booking.com
          </a>
          <a href={kayakLink} target="_blank" rel="noopener noreferrer" className="platform-button kayak">
            Kayak
          </a>
          <a href={expediaLink} target="_blank" rel="noopener noreferrer" className="platform-button expedia">
            Expedia
          </a>
          <a href={tripadvisorLink} target="_blank" rel="noopener noreferrer" className="platform-button tripadvisor">
            TripAdvisor
          </a>
        </div>
      </div>
    </div>
  );
};

export default EventPreview;
